import { useEffect, useRef } from 'react';
import styles from './Pizza.module.css';
import { getRandomIndex } from '../../helpers/random';

export const Pizza = ({
  isVisible,
  currentState,
  prevStateRef,
  prizes,
  countPrizes,
  setCountPrizes,
  speedRotate,
  setFlag,
  flag,
}) => {
  const wheelRef = useRef(null);
  const spinnerRef = useRef(null);
  const spriteRef = useRef(null);

  const tickerAnim = useRef(false);

  const currentSlice = useRef(0);
  const currentPrize = useRef(null);
  const currentAngle = useRef(360);

  const prizeNodeRef = useRef([]);

  const prizeSlice = 360 / prizes.length;
  const prizeOffset = Math.floor(180 / prizes.length);

  const createPrizeNodes = () => {
    prizes.forEach(({ text, type }, i) => {
      const rotation = prizeSlice * i * -1 - prizeOffset;
      let extraClass = '';

      if (type === 'circle' || text.toLowerCase().includes('пицца')) {
        extraClass = 'circle';

        spinnerRef.current.insertAdjacentHTML(
          'beforeend',
          `<li class="${styles.prize}" style="--rotate: ${rotation}deg">
            <div class="${styles.text} ${styles[extraClass]}">${text}</div>
          </li>`
        );
      } else if (type === 'percent' || text.includes('%')) {
        extraClass = 'percent';

        spinnerRef.current.insertAdjacentHTML(
          'beforeend',
          `<li class="${styles.prize}" style="--rotate: ${rotation}deg">
            <div class="${styles.text} ${styles[extraClass]}">${text.slice(
            0,
            text.length - 1
          )}
                <span>${text.slice(-1)}</span>
            </div>
          </li>`
        );
      } else if (
        type === 'certificate' ||
        text.toLowerCase().includes('сертификат')
      ) {
        extraClass = 'certificate';
        let words = text.split(' ');
        spinnerRef.current.insertAdjacentHTML(
          'beforeend',
          `<li class="${styles.prize}" style="--rotate: ${rotation}deg; z-index: 1000">
                <div class="${styles.text} ${styles[extraClass]}">
                    <span>${words[0]}</span>
                    <span>${words[1]}</span>
                </div>
              </li>`
        );
      }
    });
  };

  const setupWheel = () => {
    createPrizeNodes();
    prizeNodeRef.current = wheelRef.current.querySelectorAll(
      `.${styles.prize}`
    );
  };

  useEffect(() => {
    setupWheel();
    return () => cancelAnimationFrame(tickerAnim.current);
  }, []);

  const runTickerAnimation = () => {
    const spinnerStyles = spinnerRef?.current
      ? window.getComputedStyle(spinnerRef?.current)
      : {};
    // взял код анимации отсюда: https://css-tricks.com/get-value-of-css-rotation-through-javascript/
    const values = spinnerStyles?.transform
      ?.split('(')[1]
      .split(')')[0]
      .split(',');
    const a = values[0];
    const b = values[1];
    let rad = Math.atan2(b, a);

    if (rad < 0) rad += 2 * Math.PI;

    const angle = Math.round(rad * (180 / Math.PI));
    const slice = Math.floor(angle / prizeSlice);

    if (spinnerRef.current.classList.contains(styles.default)) {
      spinnerRef.current.classList.remove(styles.default);
    }
    spinnerRef.current.style.setProperty('--rotate', currentAngle.current);

    if (currentSlice.current !== slice) {
      currentSlice.current = slice;
    }

    if (
      currentSlice.current === currentPrize.current &&
      currentAngle.current === currentSlice.current * 45 + 22.5
    ) {
      cancelAnimationFrame(tickerAnim.current);
      tickerAnim.current = false;
      prizeNodeRef.current[currentSlice.current].classList.add(styles.selected);

      requestAnimationFrame(() =>
        spriteRef.current.classList.add(styles.animate)
      );

      return;
    }

    currentAngle.current =
      currentAngle.current === 0 ? 360 : currentAngle.current - speedRotate;

    // запускаем анимацию
    tickerAnim.current = requestAnimationFrame(runTickerAnimation);
  };

  useEffect(() => {
    if (currentState === 'S1') {
      if (flag) {
        setFlag(false);
      }

      if (currentPrize.current !== null) {
        prizeNodeRef.current[currentPrize.current].classList.remove(
          styles.selected
        );
        prizeNodeRef.current[currentPrize.current].classList.add(styles.right);

        requestAnimationFrame(() => {
          spriteRef.current.classList.remove(styles.animate);
          spriteRef.current.classList.add(styles.returnHand);
        });
      }

      setTimeout(
        () => {
          cancelAnimationFrame(tickerAnim.current);
          currentAngle.current = 360;
          spinnerRef.current.classList.add(styles.default);
          spinnerRef.current.style.setProperty(
            '--rotate',
            currentAngle.current
          );
          spriteRef.current.classList.remove(styles.returnHand);
          if (currentPrize.current !== null) {
            prizeNodeRef.current[currentPrize.current].classList.remove(
              styles.right
            );
          }
          currentPrize.current = null;
        },
        currentPrize.current !== null ? 600 : 0
      );
    }

    if (
      !flag &&
      currentState === 'S3' &&
      ['S2', 'S4'].includes(prevStateRef) &&
      countPrizes?.length
    ) {
      let indexRandom = getRandomIndex(0, countPrizes.length - 1);
      //   console.log(countPrizes[indexRandom]);
      currentPrize.current = prizes
        .map((p) => p.text)
        .indexOf(countPrizes[indexRandom]);

      let newCountPrize = [...countPrizes];
      newCountPrize.splice(indexRandom, 1);
      //   console.log(newCountPrize);
      setCountPrizes(newCountPrize);
    }

    if (
      !flag &&
      currentState &&
      !['S2', 'S3'].includes(currentState) &&
      ['S2', 'S4'].includes(prevStateRef) &&
      countPrizes?.length
    ) {
      let indexPrize =
        Number(currentState?.slice(1, currentState.length) || 0) - 5; // стадии с S5
      let textPrize = prizes[indexPrize]?.text;

      if (textPrize && countPrizes.includes(textPrize)) {
        currentPrize.current = indexPrize;
        // console.log(textPrize);
        let indexRemovePrize = countPrizes.indexOf(textPrize);
        let newCountPrize = [...countPrizes];
        newCountPrize.splice(indexRemovePrize, 1);
        // console.log(newCountPrize);
        setCountPrizes(newCountPrize);
      }
    }

    if (currentState === 'S2') {
      if (flag) {
        setFlag(false);
      }

      if (tickerAnim.current) {
        cancelAnimationFrame(tickerAnim.current);
        tickerAnim.current = false;
      }

      if (currentPrize.current !== null) {
        prizeNodeRef.current[currentPrize.current].classList.remove(
          styles.selected
        );
        prizeNodeRef.current[currentPrize.current].classList.add(styles.right);

        requestAnimationFrame(() => {
          spriteRef.current.classList.remove(styles.animate);
          spriteRef.current.classList.add(styles.returnHand);
        });
      }

      setTimeout(
        () => {
          if (currentPrize.current !== null) {
            prizeNodeRef.current[currentPrize.current].classList.remove(
              styles.right
            );
          }

          spriteRef.current.classList.remove(styles.returnHand);

          if (!wheelRef.current.classList.contains(styles.isSpinning)) {
            wheelRef.current.classList.add(styles.isSpinning);
          }

          currentPrize.current = null;
          runTickerAnimation();
        },
        currentPrize.current !== null ? 1000 : 0
      );
    }
  }, [currentState]);

  useEffect(() => {
    if (!isVisible) {
      setFlag(true);
    }
  }, [isVisible]);

  return (
    <div className={styles.dealWheel} ref={wheelRef}>
      <ul ref={spinnerRef} className={styles.spinner} />
      <div className={styles.sprite} ref={spriteRef} />
    </div>
  );
};
